<template>
  <v-content>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <v-card class="elevation-12">
            <v-toolbar dark color="primary">
              <v-toolbar-title>Ingrese número de documento y celular</v-toolbar-title>
            </v-toolbar>
            <v-card-text class="pb-0">
              <v-form ref="form" @submit.prevent="handleSubmit">
                <v-text-field
                    v-model="documento"
                    :rules="documentoRules"
                    id="documento"
                    prepend-icon="person"
                    name="documento"
                    label="Documento"
                    type="number"
                    autocomplete>
                </v-text-field>
                <v-text-field
                    v-model="celular"
                    :rules="documentoRules"
                    id="celular"
                    prepend-icon="phone"
                    name="celular"
                    label="Celular"
                    type="number"
                    autocomplete>
                </v-text-field>
                <v-text-field
                    v-model="email"
                    :rules="documentoRules"
                    id="email"
                    prepend-icon="email"
                    name="email"
                    label="Email"
                    type="email"
                    autocomplete>
                </v-text-field>

              </v-form>
            </v-card-text>
            <v-card-actions class="px-5">
              <v-flex class="px-5 pb-2 mt-3">
                <vue-recaptcha sitekey="6LfzC3gUAAAAALNZDhui-5B_f8QK7esVs8Or1eMu">
                  <v-btn @click="submit" :disabled="!valid" color="primary">
                    Consultar
                  </v-btn>
                  <v-btn @click="devolver"  color="primary" >
                    Volver
                  </v-btn>
                </vue-recaptcha>
                
                  
                
              </v-flex>
            </v-card-actions>
          </v-card>

  <v-dialog
          v-model="dialog3"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
          scrollable
        >
          <v-card tile>
            <v-toolbar
              flat
              dark
              color="primary"
            >
              <v-btn
                icon
                dark
                @click="dialog3 = false"
              >
                <v-icon>cancel</v-icon>
              </v-btn>
              <v-toolbar-title>Settings</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn
                  dark
                  text
                  @click="dialog = false"
                >
                  Save
                </v-btn>
              </v-toolbar-items>
              <v-menu
                bottom
                right
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    dark
                    icon
                    v-on="on"
                  >
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, i) in items"
                    :key="i"
                    @click="() => {}"
                  >
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-toolbar>
            <v-card-text>
              <v-divider></v-divider>
              <v-list
                three-line
                subheader
              >
                <v-subheader>General</v-subheader>
                <v-list-item>
                  <v-list-item-action>
                    <v-checkbox v-model="notifications"></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Notifications</v-list-item-title>
                    <v-list-item-subtitle>Notify me about updates to apps or games that I downloaded</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-action>
                    <v-checkbox v-model="sound"></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Sound</v-list-item-title>
                    <v-list-item-subtitle>Auto-update apps at any time. Data charges may apply</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-action>
                    <v-checkbox v-model="widgets"></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Auto-add widgets</v-list-item-title>
                    <v-list-item-subtitle>Automatically add home screen widgets</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
  
            <div style="flex: 1 1 auto;"></div>
          </v-card>
        </v-dialog>

        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
  import VueRecaptcha from 'vue-recaptcha';
  import {router} from '../router';
  export default {
    data: () => ({
      dialog3: false,
      celular: '3007395441',
      documento: '1082904384',
      email: 'juan.sierracastro@hotmail.com',
      documentoRules: [
        v => !!v || 'Debe ingresar su número de documento',
      ],
      valid: true,
      info: []
    }),
    methods: {
      submit() {
        this.dialog3= true
        if (this.documento) {
          
          this.info.push({
            documento: this.documento,
            celular: this.celular,
            email: this.email
          });

          
          
        }else{

        }
      },
      devolver() {
          router.push('/');
      }
    },
    components: {
      VueRecaptcha
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Consulta.vue